const entity = {
    create_failed: '{{name}} 생성을 실패하였어요.',
    not_exists: '{{name}}는 존재하지 않아요.',
    not_exists_with_id: '{{id}} ID를 가진 {{name}}는 존재하지 않아요.',
    not_found: '리소스가 존재하지 않아요.',
};
export default entity;
